export default "__VITE_ASSET__wxOnqdyp__"